import { FC } from 'react';
import { Box, Button, Container, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useStudyQuery } from '../../graphql/generated/operations/study.ts';
import { Paths } from '../../constants/paths.ts';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics.ts';

export const WelcomePage: FC = () => {
  const { data } = useStudyQuery();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        py: 5
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box component="img" src="/logo.svg" alt="logo" sx={{ height: '8rem', mb: 3 }} />
        <Box textAlign="center">
          <Typography variant="h4" paragraph>
            Welcome to the ABLE app!
          </Typography>
          <Typography variant="h5" paragraph>
            (Active Behaviors Living Empowered)
          </Typography>
        </Box>
        <Typography sx={{ fontSize: '1.125rem' }}>
          Research has shown that identifying and scheduling activities increases well-being, and happiness, and reduces stress. This app will help you identify activities that are
          customized to your values and goals.
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Discover new activities" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Recommit to activities you haven’t had time for" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Discover a hidden talent or creative side" />
          </ListItem>
        </List>
        <Typography sx={{ fontSize: '1.125rem' }}>{data?.study.thisProgramIsBased}</Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={() => {
            navigate(Paths.USER_INFO);
            trackEvent('onboarding_start');
          }}
        >
          Get Started
        </Button>
      </Container>
    </Box>
  );
};
